var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrandCollapsed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4066F6",
    fillRule: "evenodd",
    d: "m21.579 9.384 4.557-3.427v2.067s4.707.707 4.734 6.32c-.081 5.132-4.619 6.247-6.671 6.288-4.376-.014-6.87-3.074-7.023-6.167s-.122-5.621-.189-6.935-1.182-3.157-3.439-3.042c-2.38-.109-3.476 2.448-3.637 3.042-.108.766-.233 1.69-.233 2.489-.794 0-1.712-.005-2.557.29-.776.248-3.207 1.833-3.044 4.036s1.647 3.335 3.044 3.417c1.034.082 3.799 0 5.553 0v-2.329l4.151 3.77-4.15 3.428v-1.999s-3.67.014-5.554 0c-1.883-.014-5.854-.919-5.988-6.287-.136-5.369 4.876-6.955 5.5-7.173.193-.605 1.456-5.816 6.915-5.803 5.762.073 6.598 5.159 6.626 6.16.027.954.246 6.754.252 6.816.13 1.254 1.26 3.117 3.773 3.172 2.025 0 3.647-1.348 3.727-3.291-.041-2.294-1.79-3.02-1.79-3.02v2.013z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrandCollapsed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/brand-collapsed.f77daac4.svg";